export * from './lib/services/clipboard/clipboard.service';
